import { chakra } from '@chakra-ui/react'

export const Highlight = chakra('span', {
  baseStyle: {
    fontWeight: 'semibold',
  },
})

export const Description = chakra('p', {
  baseStyle: {
    color: 'greys.400',
  },
})

export const Caption = chakra('p', {
  baseStyle: {
    fontSize: 'sm',
  },
})

export const Underlined = chakra('span', {
  baseStyle: {
    textDecoration: 'underline',
  },
})
